
export default [
	'ААВ',
	'ХХХ',
	'ТТТ',
	'ААМ',
	'РРР',
	'ННН',
	'ККК',
	'ССС',
	'ЕЕЕ',
	'ААН'
];
